import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Text } from '@topconagriculture/react-components';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter, formatDate, formatNumberByRegion, getDateTimeFormat, toFarmTimeZone, } from '../../../../utils/utils';
const useStyles = makeStyles(() => ({
    capitalized: { textTransform: 'capitalize' },
    tooltip: {
        width: 400,
        border: '1px solid #EBF0F4',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        backgroundColor: '#E6ECF1',
    },
    header: { textAlign: 'center', backgroundColor: '#FFF' },
    line: { display: 'flex', padding: 3, backgroundColor: '#FFF' },
    title: {
        textAlign: 'left',
        width: '50%',
        paddingLeft: 10,
    },
    value: { textAlign: 'center', width: '50%', backgroundColor: '#F1F1F1' },
}));
const TooltipLine = ({ title, value, bold = false }) => {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.line },
        React.createElement("div", { className: classes.title },
            React.createElement(Text, { bold: true }, capitalizeFirstLetter(title))),
        React.createElement("div", { className: classes.value },
            React.createElement(Text, { bold: bold }, value))));
};
export const ChartTooltip = ({ data = {}, weightUnit }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { tolerance, deviation, deviationPerc = 0, rationName, dateTime, driverName, farmParams } = data;
    const dateFormat = getDateTimeFormat(true);
    const date = dateTime && farmParams ? formatDate(toFarmTimeZone(new Date(dateTime), farmParams.timeZone), dateFormat) : '';
    const weightToleranceTitle = `${t('widget:weight_tolerance')} (${weightUnit})`;
    const deviationTitle = `${t('widget:deviation')} (${weightUnit})`;
    const deviationPercTitle = `${t('widget:deviation')} (%)`;
    const deviationPercFormatted = formatNumberByRegion(deviationPerc, 2);
    return (React.createElement("div", { className: classes.tooltip },
        React.createElement("div", { className: classes.header },
            React.createElement(Text, { className: classes.capitalized, bold: true }, t('widget:load_info'))),
        React.createElement(TooltipLine, { title: weightToleranceTitle, value: tolerance, bold: true }),
        React.createElement(TooltipLine, { title: deviationTitle, value: deviation, bold: true }),
        React.createElement(TooltipLine, { title: deviationPercTitle, value: deviationPercFormatted, bold: true }),
        React.createElement(TooltipLine, { title: t('widget:recipe'), value: rationName }),
        React.createElement(TooltipLine, { title: t('widget:date_time'), value: date }),
        React.createElement(TooltipLine, { title: t('common:operator'), value: driverName })));
};
//# sourceMappingURL=ChartTooltip.js.map